/* SEMEX brand rehaul kit — tiny runtime: fade-ups, hero video, tile scroller. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Fade-ups */
  var fades = document.querySelectorAll('.smx-rb-fade');
  if (reduce || !('IntersectionObserver' in window)) {
    fades.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    fades.forEach(function (el) { io.observe(el); });
    /* Fallback: never leave content hidden if the observer never fires (prerender, frozen observers) */
    setTimeout(function () { fades.forEach(function (el) { el.classList.add('is-in'); }); }, 1500);
  }

  /* Hero video: make sure it plays (muted autoplay can still be blocked) */
  document.querySelectorAll('video.smx-rb-autoplay').forEach(function (v) {
    if (reduce) { v.pause(); return; }
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('muted', '');
    var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
  });

  /* Count-up on business-fact stats (100K+, 10,000+, 1,356) */
  var stats = document.querySelectorAll('[data-count]');
  function countUp(el) {
    var raw = el.getAttribute('data-count'); var m = raw.match(/^([\d,\.]+)(.*)$/); if (!m) return;
    var target = parseFloat(m[1].replace(/,/g, '')); var suffix = m[2]; var hasComma = m[1].indexOf(',') >= 0; var t0 = null; var dur = 1400;
    function fmt(n) { n = Math.round(n); return (hasComma ? n.toLocaleString('en-US') : String(n)) + suffix; }
    function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(target * e); if (p < 1) requestAnimationFrame(step); else el.textContent = raw; }
    requestAnimationFrame(step);
  }
  if (reduce || !('IntersectionObserver' in window)) { stats.forEach(function (el) { el.textContent = el.getAttribute('data-count'); }); }
  else { var so = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); so.unobserve(e.target); } }); }, { threshold: 0.4 }); stats.forEach(function (el) { so.observe(el); }); }

  /* Actives scroller nav */
  document.querySelectorAll('[data-smx-rb-scroller]').forEach(function (wrap) {
    var row = wrap.querySelector('.smx-rb-actives__row');
    if (!row) return;
    wrap.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tile = row.querySelector('.smx-rb-tile');
        var step = tile ? tile.getBoundingClientRect().width + 20 : 320;
        row.scrollBy({ left: step * (btn.getAttribute('data-dir') === 'next' ? 1 : -1), behavior: 'smooth' });
      });
    });
  });

  /* Closing CTA on the product page: add straight to cart with the buy box's selected plan */
  document.querySelectorAll('[data-smx-rb-cta-atc]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (typeof window.smxRbAdd === 'function') { e.preventDefault(); window.smxRbAdd(); } });
  });

  /* App-block hosts: if the third-party widget never renders (blocked, failed, removed), hide the host so no empty panel ships */
  function judgeApps() {
    document.querySelectorAll('.smx-rb-apps').forEach(function (sec) {
      var inner = sec.querySelector('.smx-rb-apps__in'); if (!inner) return;
      var hasContent = inner.getBoundingClientRect().height > 60 || inner.querySelector('iframe, video, img, canvas');
      sec.classList.toggle('is-empty', !hasContent);
    });
  }
  setTimeout(judgeApps, 2500); setTimeout(judgeApps, 6000); setTimeout(judgeApps, 12000);
})();
